import React, { useEffect, useState } from "react";
import { getfooterinfo } from "../../../../Services/service";

function Footer() {
const [footerinfo, setFooterinfo]=useState()

useEffect(() => {
      loadData();
    }, []);
  
    async function loadData() {
      const fn = await getfooterinfo();
      setFooterinfo(fn); 
      // console.log(fn)
    }
    // console.log(footerinfo)
  return (
    <>
      <footer className="binduz-er-footer-area-4">
        {footerinfo && footerinfo.footerinfo.map((item)=>{
          return(

          
        <div className=" container">
          <div className="row">
            <div className=" col-lg-12">
              <div className="row footer-row">
                <div className=" col-lg-3">
                  <div className="binduz-er-footer-about binduz-er-footer-about-4">
                    <div className="binduz-er-logo">
                      <a href="/">
                        <img
                          src={
                            require(`../../../../assets/images/logo-7.png`)
                              .default
                          }
                          alt=""
                        />
                      </a>
                    </div>
                    <p>
                      {item.p1}
                    </p>
                    <ul>
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-behance"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className=" col-lg-5  footer-row-2">
                  <div className="binduz-er-footer-gallery ml-50">
                    <div className="binduz-er-footer-title">
                      <h4 className="binduz-er-title">{item.pshowcase}</h4>
                    </div>
                    <div className="binduz-er-footer-gallery-widget d-flex">
                      <div className="binduz-er-item">
                        <a href="#">
                          <img
                            src={
                              require(`../../../../assets/images/footer-gallery-1.jpg`)
                                .default
                            }
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="binduz-er-item">
                        <a href="#">
                          <img
                            src={
                              require(`../../../../assets/images/footer-gallery-2.jpg`)
                                .default
                            }
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="binduz-er-item">
                        <a href="#">
                          <img
                            src={
                              require(`../../../../assets/images/footer-gallery-3.jpg`)
                                .default
                            }
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                    <div className="binduz-er-footer-gallery-widget d-flex">
                      <div className="binduz-er-item">
                        <a href="#">
                          <img
                            src={
                              require(`../../../../assets/images/footer-gallery-4.jpg`)
                                .default
                            }
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="binduz-er-item">
                        <a href="#">
                          <img
                            src={
                              require(`../../../../assets/images/footer-gallery-5.jpg`)
                                .default
                            }
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="binduz-er-item">
                        <a href="#">
                          <img
                            src={
                              require(`../../../../assets/images/footer-gallery-6.jpg`)
                                .default
                            }
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-lg-4">
                  <div className="binduz-er-footer-navigation binduz-er-footer-navigation-4">
                    <div className="binduz-er-footer-title">
                      <h3 className="binduz-er-title">{item.cinfo}</h3>
                    </div>
                    <div className="binduz-er-footer-list">
                      <ul>
                        <li>
                          <a href="/about">{item.abus}</a>
                        </li>
                        <li>
                          <a href="/contact">{item.tserv}</a>
                        </li>
                        <li>
                          <a href="/contact">{item.s1}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.s2}</a>
                        </li>
                        <li>
                          <a href="/contact">{item.s3}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.s4}</a>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <a href="/contact">{item.s5}</a>
                        </li>
                        <li>
                          <a href="/contact">{item.s6}</a>
                        </li>
                        <li>
                          <a href="/archived">{item.s7}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.s8}</a>
                        </li>
                        <li>
                          <a href="/News-details/1299">{item.s9}</a>
                        </li>
                        <li>
                          <a href="/News-details/1299">{item.s10}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )})}
      </footer>
      <div className="binduz-er-footer-copyright-area binduz-er-footer-copyright-area-4">
        {footerinfo && footerinfo.companyinfo.map((item)=>{
          return(
        <div className=" container">
          <div className="row align-items-center">
            <div className=" col-lg-6">
              <div className="binduz-er-copyright-text">
                <p>
                {item.c1}<span>{item.c2}</span> {item.year}
                </p>
              </div>
            </div>
            <div className=" col-lg-6">
              <div className="binduz-er-copyright-menu float-lg-end float-none">
                <ul>
                  <li>
                    <a href="#">{item.c3}</a>
                  </li>
                  <li>
                    <a href="#">{item.c4}</a>
                  </li>
                  <li>
                    <a href="#">{item.c5}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        )})}
      </div>
    </>
  );
}

export default Footer;
